/**
 * Read-side styling for server-sanitized `rich_text` HTML.
 *
 * One constant, because there is one allowlist: whatever nh3 lets through
 * (curriculum/blocks.py, FE-ADR-011) has to look right wherever it is rendered
 * — lesson blocks, homework briefs, announcements. A second copy would drift
 * the moment the allowlist gains a tag.
 */
export const RICH_TEXT_PROSE_CLASS =
  // max-w-3xl caps the MEASURE, not the card: the surrounding frame keeps the
  // page's full width; only the prose inside stops at a readable line length.
  'max-w-3xl text-sm leading-relaxed [&_h2]:mt-4 [&_h2]:text-lg [&_h2]:font-semibold [&_h3]:mt-3 [&_h3]:text-base [&_h3]:font-semibold ' +
  '[&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 ' +
  '[&_blockquote]:border-l-2 [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground ' +
  '[&_a]:text-primary [&_a]:underline ' +
  '[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 ' +
  '[&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:bg-muted [&_pre]:p-2 [&_pre_code]:bg-transparent [&_pre_code]:px-0 ' +
  // Tables (ADR-033/FE-ADR-027). `block` + overflow keeps a wide table
  // scrolling inside its own box instead of breaking the page on phones —
  // the sanitized HTML is raw <table>, there is no wrapper div to scroll.
  '[&_table]:my-3 [&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto [&_table]:border-collapse ' +
  '[&_th]:border [&_th]:bg-muted [&_th]:p-1.5 [&_th]:text-left [&_th]:font-semibold ' +
  '[&_td]:border [&_td]:p-1.5 [&_td]:align-top';
